import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import UnknownTemplate from '../../render_components/__template_components/unknown_template';
import PublicationPageV2 from '../../render_components/__template_components/publication_page_v2';
import ArticlePage from '../../render_components/__template_components/article_list/article_page';
import ArticleFreePage from '../../render_components/__template_components/article_free/article_free_page';
import ItemPageV1 from '../../render_components/__template_components/item_page_v1';
import ItemPage from '../../render_components/__template_components/item/item_page';
import CartV1 from '../../render_components/__template_components/cart_v1';
import Cart from '../../render_components/__template_components/cart';
import { safeJsonParse } from '../../../utils/safeJsonParse';

const parsePublicationContent = (rawContent) => {
  if (!rawContent) return null;
  if (Array.isArray(rawContent)) return rawContent;
  if (typeof rawContent === 'object') return rawContent;
  if (typeof rawContent === 'string') {
    try {
      const parsed = JSON.parse(rawContent);
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return safeJsonParse(rawContent, null);
    }
  }
  return null;
};

const parsePublicationTemplate = (rawTemplate) => {
  if (!rawTemplate) return null;
  if (typeof rawTemplate === 'object') return rawTemplate;
  if (typeof rawTemplate === 'string') return safeJsonParse(rawTemplate, null);
  return null;
};

const PublicationPage = () => {
  const currentPublication = useSelector((state) => state.currentPublication.currentPublication);
  const parsedTemplate = parsePublicationTemplate(currentPublication?.template);
  const templateName = parsedTemplate?.template_name || null;
  const contentData = parsePublicationContent(currentPublication?.content);

  React.useEffect(() => {
    if (!currentPublication) return;
    const name = currentPublication?.template?.template_name ?? '(нет шаблона)';
    console.log('[PublicationPage]', name, {
      show_name: currentPublication?.show_name,
      eng_name: currentPublication?.eng_name,
    });
  }, [currentPublication]);

  const path_to_folder = currentPublication
    ? 'https://' + currentPublication.path + currentPublication.eng_name + '/'
    : null;

  const renderTemplate = () => {
    switch (templateName) {
      case 'Publication_1':
        return <PublicationPageV2 contentData={contentData} path_to_folder={path_to_folder} />;
      case 'publication_v2':
        return <PublicationPageV2 contentData={contentData} path_to_folder={path_to_folder} />;
      case 'article_list':
        return <ArticlePage contentData={contentData} path_to_folder={path_to_folder} />;
      case 'article_free':
        return (
          <ArticleFreePage
            contentData={contentData}
            path_to_folder={path_to_folder}
            template={parsedTemplate ?? currentPublication?.template}
            publication={currentPublication}
          />
        );
      case 'item_data_v1':
        return <ItemPageV1 contentData={contentData} path_to_folder={path_to_folder} />;
      case 'item':
        return <ItemPage contentData={contentData} path_to_folder={path_to_folder} />;
      case 'cart_v1':
        return <CartV1 publication={currentPublication} />;
      case 'cart':
        return <Cart publication={currentPublication} />;
      default:
        return <UnknownTemplate contentData={contentData} path_to_folder={path_to_folder} />;
    }
  };

  const templateContent = renderTemplate();

  if (!templateContent) {
    return null;
  }

  return <div className={styles.publicationPage}>{templateContent}</div>;
};

export default PublicationPage;
